<template>
  <el-dropdown class="dep-tree-dropdown-menu" trigger="click">
    <span class="el-dropdown-link" @click.stop>
      <i class="dep-tree-dropdown-menu__drop-icon el-icon-more"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item class="dep-tree-dropdown-menu__item">
        <router-link :to="{ name: 'orgEdit', params: { id: node.data.id } }">
          <div class="dep-tree-dropdown-menu__item-icon">
            <img src="static/img/icon_dropmenu_edit.svg" alt="I">
          </div>
          <span>{{ $t('labels.edit') }}</span>
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item class="dep-tree-dropdown-menu__item">
        <router-link :to="{ name: 'orgCreate', query: { parent: node.data.id } }">
          <div class="dep-tree-dropdown-menu__item-icon">
            <img src="static/img/icon_dropmenu_plus.svg" alt="I">
          </div>
          <span>{{ $t('orgs.add_subdivision') }}</span>
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item class="dep-tree-dropdown-menu__item">
        <a @click="deleteOrg(node.data.id, node.data.name)">
          <div class="dep-tree-dropdown-menu__item-icon">
            <img src="static/img/icon_dropmenu_trash.svg" alt="I">
          </div>
          <span>{{ $t('labels.delete') }}</span>
        </a>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
  export default {
    props: ['node'],
    methods: {
      deleteOrg (id, name) {
        this.$emit('deleteOrg', id, name)
      }
    },
    computed: {
    },
    created () {
      // this.$store.dispatch('users/loadOrgPerms', this.node.data.getId());
    }
  }
</script>